let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gQSWJ")).then(() => parcelRequire('k1A8C'));